import React from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import useCopy from 'ggApp/shared/common/CopyBox/hooks/useCopy';

import { Button, ButtonText, CopyIcon, CheckMarkIcon } from './styled';

type CopyBoxProps = {
    className?: string;
    textToCopy?: string;
    displayText?: string;
    onCopied?: () => void;
};

const CopyBox = ({
    className,
    displayText = '',
    textToCopy,
    onCopied,
}: CopyBoxProps): JSX.Element => {
    const { isActive, copyToClipboard } = useCopy({ textToCopy, displayText, onCopied });

    const copyBoxTK = isActive ? 'REFERRALS_COPIED_NOTIFICATION' : 'COPY_BOX_COPY_CODE';

    return (
        <Button className={className} onClick={copyToClipboard} isActive={isActive}>
            {!isActive && <CopyIcon />}
            {isActive && <CheckMarkIcon />}
            <ButtonText>
                <Translator tk={copyBoxTK} />
            </ButtonText>
        </Button>
    );
};

export default CopyBox;
